import { CompareActionTypes, SingleProductTileActionTypes, WishListActionTypes } from '../../../enums/ActionEnums';
import { toggleComparedStateForItems } from '../../../redux/compare/reducers/CompareReducer';
import { updateWishListProducts, initializeWishListProducts } from '../../../redux/wishList/reducers/WishListReducer';
import { setDeliveryPromiseToProducts } from '../../../util/ProductUtil';
export const initialState = [];
const addProductToList = (products, newProduct) => {
    const product = products.find(({ productCode, colourId }) => newProduct.productCode === productCode && newProduct.colourId === colourId);
    if (product) {
        return products;
    }
    return [...products, newProduct];
};
const addBulkProductsToList = (products, newProducts) => {
    const mergedProducts = [...products, ...newProducts];
    return mergedProducts.filter((product, index, array) => index ===
        array.findIndex(item => item.productId === product.productId && item.productCode === product.productCode));
};
export const loadSingleProductTileReducer = (state = initialState, action) => {
    switch (action.type) {
        case SingleProductTileActionTypes.ADD_PRODUCT_TO_LIST:
            return addProductToList(state, action.payload);
        case SingleProductTileActionTypes.ADD_BULK_PRODUCTS_TO_LIST:
            return addBulkProductsToList(state, action.payload);
        case WishListActionTypes.UPDATE_PRODUCTS:
            return initializeWishListProducts(state, action);
        case WishListActionTypes.ADD_PRODUCT:
            return updateWishListProducts(state, action, true);
        case WishListActionTypes.REMOVE_PRODUCT:
            return updateWishListProducts(state, action, false);
        case CompareActionTypes.COMPARE_UPDATE_PRODUCTS:
            return toggleComparedStateForItems(state, action.payload);
        case SingleProductTileActionTypes.SET_DELIVERY_PROMISE:
            return setDeliveryPromiseToProducts(state, action.payload);
        default:
            return state;
    }
};
export const singleProductTileReducer = loadSingleProductTileReducer;
